<!--
 * @Author: hucaili 735856642@qq.com
 * @Date: 2023-06-09 11:45:34
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2023-06-10 14:55:52
 * @FilePath: \fe-crm\src\components\public\xl-select-contacts\xl-select-contacts.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="page-comp-select-contacts" v-if="visible">
    <jw-modal v-model:visible="visible" @cancel="contactsHide" title-align="start" :footer="false" width="650px">
      <template #title> {{ $t('联系人拨打') }} </template>
      <div>
        <xl-table :columns="columns" :data="contactList" :loading="loading" :pagination="false">
          <template #name="{ record }">
            <span :style="{ display: 'flex', textAlign: 'center' }">
              <span class="clue-dial-name" :title="record?.name">{{ record?.name || '-' }}</span>
              <span class="clue-dial-default" v-if="record.isDefault" type="text">★</span>
            </span>
          </template>
          <template #jobTitle="{ record }">
            <span class="clue-dial-jobTitle">{{ record?.jobTitle || '-' }}</span>
          </template>
          <template #kdm="{ record }">
            <jw-tag color="pinkpurple" size="small" v-if="record?.kdm === 0">KDM</jw-tag>
            <jw-tag color="orange" size="small" v-else-if="record?.kdm === 2">{{ $t('老板委派调研人') }}</jw-tag>
            <span color="orange" v-else>{{ record?.kdmName || '-' }}</span>
          </template>
          <template #operation="{ record }">
            <jw-button type="primary" size="mini" @click="dialPhone(record)" :disabled="record.id === callId && outCallDisabled">拨打</jw-button>
          </template>
        </xl-table>
      </div>
    </jw-modal>
    <!-- 天科云外呼 S -->
    <xl-out-call-tky ref="tkyRef" />
    <!-- 天科云外呼 E -->
    <!-- 传显科技 - 外呼 S -->
    <xl-out-call-cxkj ref="cxkjRef" />
    <!-- 传显科技 - 外呼 E -->
  </div>
</template>

<script>
import { reactive, toRefs, inject, ref } from 'vue';
import { useContactsStore, useOutCallStore } from '@/store';
import { useI18n } from 'vue-i18n';
// import { lingChuOrgId } from '@/utils/const';
export default {
  name: 'XlSelectContacts',
  setup(props, ctx) {
    const { t } = useI18n();
    console.log(props, ctx);
    const { callConfig } = useOutCallStore(); // 外呼列表
    // 领储7  天客云tkyRef
    const tkyRef = ref();
    // 条道12  传显科技cxkjRef
    const cxkjRef = ref();
    const getContacts = useContactsStore(); //拨打电话store
    const getContactsList = getContacts.selectContacts; //拨打电话-获取联系人
    const contactsShow = () => {
      data.contactList = [];
      data.visible = true;
      getContactsList.data?.forEach((item) => {
        console.log(52, item);
        const { id, name, jobTitle, kdmName, mobile, isDefault, kdm, businessId } = item;
        data.contactList.push({ id, name, jobTitle, kdmName, mobile, isDefault, kdm, businessId });
      });
      data.visible = true;
    };
    const contactsHide = () => {
      data.visible = false;
    };
    // 拨打电话
    const dialPhone = (record) => {
      // console.log('拨打电话60', record);
      data.callId = record.id;
      data.outCallDisabled = true;
      // 如果orgid 是7 是领储 则展示天科云
      // console.log(5357, lingChuOrgId);
      if (callConfig.default?.platformCode === 'kty') {
        tkyRef.value?.open({ id: record?.businessId, type: data?.entity, linkManId: record?.id || data.id });
        data.outCallDisabled = false;
        return;
      }
      // 如果orgid 是12 是条道 则传显科技
      if (callConfig.default?.platformCode === 'cx') {
        cxkjRef.value?.open({ id: record?.businessId, type: data?.entity, linkManId: record?.id || data.id });
        data.outCallDisabled = false;
        return;
      }
      getContacts
        .callOut({
          linkManId: record?.id || data.id,
          id: record?.businessId,
          type: data?.entity,
          callee: record?.mobile,
          calleeName: record?.name
        })
        .then((res) => {
          console.log('callOut  ---> ', res);
          data.outCallDisabled = false;
          if (!res.error) {
            contactsShow();
            console.log('----------------');
            data.visible = false;
          } else {
            console.log('================');
            data.visible = true;
          }
        });
    };
    const data = reactive({
      visible: false,
      loading: false,
      contactList: [],
      callId: null,
      outCallDisabled: false,
      columns: [
        { title: t('联系人'), dataIndex: 'name', slotName: 'name' },
        { title: t('职位'), dataIndex: 'jobTitle', slotName: 'jobTitle', width: 100, ellipsis: true, tooltip: true },
        { title: t('是否KDM'), dataIndex: 'kdm', slotName: 'kdm', width: 150 },
        { title: t('手机号'), dataIndex: 'mobile', width: 130 },
        { title: t('操作'), dataIndex: 'operation', slotName: 'operation', width: 80 }
      ],
      id: inject('defaultParams').id,
      entity: inject('defaultParams').entity //类型1-线索 2-客户 3-商机 4-产品
    });
    return {
      open,
      tkyRef,
      cxkjRef,
      contactsHide,
      contactsShow,
      dialPhone,
      ...toRefs(data)
    };
  }
};
</script>
<style scoped lang="less">
@import './xl-select-contacts.less';
</style>
